import { Box, makeStyles } from '@material-ui/core';
import { TriangleIcon } from '../../../../components/Icon';
import Text from '../../../../components/Text';
import { classNames } from '../../../../utils';

const useStyles = makeStyles((theme) => ({
  triangleIcon: ({ color, iconSize }) => ({
    fontSize: iconSize,
    color,
  }),
  triangleText: ({ fontSize, top, left }) => ({
    fontSize,
    color: '#FFF',
    fontFamily: 'NotoSans-Bold',
    position: 'absolute',
    top,
    left,
    transform: 'translate(-50%, -50%)',
    whiteSpace: 'nowrap',
    lineHeight: '1.25rem',
  }),
  '@keyframes backgroundAnimation': {
    '0%': { opacity: 1 },
    '50%': { opacity: 0.3 },
    '100%': { opacity: 1 },
  },
  flash: {
    animation: '$backgroundAnimation 2s infinite',
  },
}));

export const Triangle = ({
  value,
  number,
  color,
  width = '1.5rem',
  height = '1.3rem',
  iconSize = '1.5rem',
  fontSize = '0.75rem',
  top = '65%',
  left = '52.5%',
}) => {
  const classes = useStyles({ color, iconSize, fontSize, top, left });

  return number === 'NA' ? (
    <Box
      width={width}
      height={height}
      borderRadius="2px"
      bgcolor="#C0C6CB"
      color={color ?? '#FFF'}
      display="flex"
      alignItems="center"
      justifyContent="center"
      fontSize={fontSize}
    >
      NA
    </Box>
  ) : (
    <Box display="flex" gridGap="0.25rem">
      <Box position="relative" display="inline-block" width={width} height={height}>
        <TriangleIcon className={classNames(classes.triangleIcon, classes.flash)} />
        <div className={classes.triangleText}>!</div>
      </Box>
      {value && <Text>{value}</Text>}
    </Box>
  );
};
